import { render } from "./NewsAreaTwo.vue?vue&type=template&id=a2a6f6fe"
import script from "./NewsAreaTwo.vue?vue&type=script&lang=js"
export * from "./NewsAreaTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__